import { userRating } from '@/api'
import { ApiResult } from '@modals/RequiredEmailConfirmation/components/RequiredEmailConfirmationModal/utils/api'

// pulses
export const updateUserRaring = async (
  userId: number,
  rating: number,
  gamificationBalance?: number,
  role?: string,
): Promise<ApiResult<Boolean>> => {
  try {
    const data = new FormData()
    data.append('user_id', String(userId))
    data.append('rating', String(rating))
    if (gamificationBalance !== undefined) {
      data.append('gamification_balance', String(gamificationBalance))
    }
    if (role) {
      data.append('role', role)
    }

    const res = await userRating.updateRating(data)
    const success = res?.data?.status === 'success'

    return {
      data: success,
      success,
      error: res?.data?.error || res?.data?.message,
    }
  } catch (error) {
    console.error('Ошибка updateUserRaring:', error)
    return {
      data: null,
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}
